import React, { ReactNode } from "react";
import { Flex, Spinner, Td, Tr, Text } from "@chakra-ui/react";

interface TableLoaderProps {
  loader: boolean;
  show: number;
  noDataText?:string;
  children: ReactNode;
  columns?:number
}

const TableLoader: React.FC<TableLoaderProps> = ({ loader, show, columns = 10, noDataText, children }) => {
  if (loader) {
    return (
      <Tr>
        <Td colSpan={columns + 1} p={5}>
          <Flex justifyContent="center">
            <Spinner />
          </Flex>
        </Td>
      </Tr>
    );
  }
  if (show === 0) {
    return (
      <Tr>
        <Td colSpan={columns + 1} p={5}>
          <Flex justifyContent="center">
            <Text fontSize="sm" color="red.400" fontWeight="bold" cursor="pointer">
              {noDataText ? noDataText : 'No Data Available to Show'}
            </Text>
          </Flex>
        </Td>
      </Tr>
    );
  }

  return <>{children}</>;
};

export default TableLoader;
